import React, { memo, useCallback, useMemo } from 'react'
import { Form, Formik } from 'formik'
import { EditTemplateTitleFormContent } from './EditTemplateTitleFormContent'
import { editTemplateTitleFormValidator } from './EditTemplateTitleForm.validator'
import type { EditTemplateTitleFormValues } from './EditTemplateTitleForm.interface'

interface Props {
  formId: string
  name: string
  onSubmit(values: EditTemplateTitleFormValues): void
}

const EditTemplateTitleFormComponent = ({ formId, name, onSubmit }: Props) => {
  const initialValues = useMemo<EditTemplateTitleFormValues>(() => {
    return { name }
  }, [name])

  const handleSubmit = useCallback(
    (values: EditTemplateTitleFormValues) => {
      onSubmit(values)
    },
    [onSubmit],
  )

  return (
    <Formik<EditTemplateTitleFormValues>
      initialValues={initialValues}
      validationSchema={editTemplateTitleFormValidator}
      // Reopening the modal must reseed the field from the template's current name, so a
      // cancelled edit is not still sitting in the input next time.
      enableReinitialize
      onSubmit={handleSubmit}
    >
      <Form id={formId}>
        <EditTemplateTitleFormContent />
      </Form>
    </Formik>
  )
}

export const EditTemplateTitleForm = memo(EditTemplateTitleFormComponent)
